import React from "react";
import { Link } from "react-router-dom";
const TicketsPage = () => {
  return (
    <div className="container">
      <h3 className="mb-4">Support</h3>

      <div className="row row-xs align-items-center mb-4">
        <div className="col-12 col-md-4 col-xl-2 mb-2">
          <input
            className="fin-control fin-control-sm"
            type="search"
            placeholder="Search uploads"
          />
        </div>
        <div className="col-12 col-sm-6 col-md-4 col-xl-2 mb-2">
          <select className="fin-control fin-control-sm">
            <option>Status</option>
            <option>New</option>
            <option>Replied</option>
            <option>Waiting for reply</option>
            <option>Closed</option>
            <option>Resolved</option>
          </select>
        </div>
      </div>

      <table className="table-list text-small">
        <thead>
          <tr>
            <th>ID</th>
            <th>SUBJECT</th>
            <th>LAST ACTIVITY</th>
            <th>STATUS</th>
            <th className="text-lg-center">POSTS</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-title="ID">1</td>
            <td data-title="SUBJECT">
              <p className="mb-1">Problem with my APIs...</p>
              <p className="text-xsmall text-muted">
                Nick Sotiriadis - National Bank of Greece
              </p>
            </td>
            <td data-title="LAST ACTIVITY">04/01/2021, 16:12</td>
            <td data-title="STATUS">Replied</td>
            <td className="text-lg-center" data-title="POSTS">
              4
            </td>
            <td className="table-actions text-md-center nowrap">
              <Link className="btn-transparent ml-n2 ml-md-0" to="/ticket">
                View
              </Link>
            </td>
          </tr>
        </tbody>
      </table>

      <ul className="pagination mt-45">
        <li className="active">
          <span className="current" tabIndex="-1">
            1
          </span>
        </li>
        <li>
          <a href="#" tabIndex="-1">
            2
          </a>
        </li>
        <li>
          <a href="#" tabIndex="-1">
            3
          </a>
        </li>
      </ul>
    </div>
  );
};

export default TicketsPage;
